import _objectWithoutProperties from "/builds/other/velness.io/verityapps-com-frontend/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import useMediaQuery from './useMediaQuery';
export default function MediaQuery(_ref) {
  var children = _ref.children,
      device = _ref.device,
      onChange = _ref.onChange,
      settings = _objectWithoutProperties(_ref, ["children", "device", "onChange"]);

  var matches = useMediaQuery(settings, device, onChange);

  if (typeof children === 'function') {
    return children(matches);
  }

  return matches ? children : null;
}